import { Injectable } from '@angular/core';
import { CityCodeResult } from '@com-delta-idp/mnx-capability-check-in-ui';
import { CheckInStaticAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AirportDropDown } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { SearchItem } from '@com-delta-omnichannel/mach-core-js';
import { CHECK_IN_SMART_CONSTANTS } from '../models/check-in-status.constants';

@Injectable({
  providedIn: 'root'
})
export class CheckInAirportAdapterService {
  initializeAirportModalContent(
    content: CheckInStaticAem,
    airportList?: CityCodeResult[]
  ): AirportDropDown {
    const { checkInForm } = content;
    return {
      airportList: {
        id: 'check-in-search-transparent',
        title: checkInForm.search.searchTitle,
        placeholder: checkInForm.search.searchAirportLabel,
        hasExternalFiltering: false,
        shouldAutoCapitalize: true,
        items: this.predictiveCitiesAdapter(airportList),
        menuVariant: CHECK_IN_SMART_CONSTANTS.CONFIG.SEARCH_MENU_TYPE,
        hasAutocomplete: false,
        shouldShowCodes: true,
        errorConfig: {
          validateOnInput: false
        }
      },
      tabOptions: {
        id: 'tabs-width-fixed-small',
        tabVariant: 'standard',
        tabSize: 'small',
        tabWidth: 'fixed',
        tabItems: [
          {
            id: 'search',
            label: checkInForm.search.label,
            value: checkInForm.search.label,
            selected: true
          }
        ],
        selectedIndex: 0
      },
      mobileCloseHeaderText: checkInForm.search.mobileCloseHeaderText,
      floatingLabelText: checkInForm.search.searchAirportLabel
    };
  }

  predictiveCitiesAdapter(cities?: CityCodeResult[]): SearchItem[] {
    return (
      cities?.map((value) => ({
        id: value.AIRPORT_CODE,
        label: `${value.CITY_NAME}, ${value.COUNTRY}`,
        code: value.AIRPORT_CODE,
        value: `${value.AIRPORT_CODE}`,
        selected: false
      })) || []
    );
  }
}
